import { render, staticRenderFns } from "./RecordHeading.vue?vue&type=template&id=9bcb5a22&scoped=true&"
import script from "./RecordHeading.vue?vue&type=script&lang=js&"
export * from "./RecordHeading.vue?vue&type=script&lang=js&"
import style0 from "./RecordHeading.vue?vue&type=style&index=0&id=9bcb5a22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcb5a22",
  null
  
)

export default component.exports